import { render, staticRenderFns } from "./budgetPreparation.vue?vue&type=template&id=6237e107&scoped=true&"
import script from "./budgetPreparation.vue?vue&type=script&lang=js&"
export * from "./budgetPreparation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6237e107",
  null
  
)

export default component.exports